import React, { useEffect, useRef, useState } from "react";

export const SealNumberComponent = React.forwardRef((props, ref) => {
  const { name, disabled, read_only, onChange, defaultValue } = props;

  // Using a ref to directly interact with the DOM element
  const inputRef = useRef(null);
  const containerRef = useRef(null);
  const [newSealValue, setNewSealValue] = useState("");

  useEffect(() => {
    if (ref) {
      ref.current = inputRef.current; // Assigning the DOM element to the forwarded ref
    }
  }, [ref]);

  // Find the new seal number from sibling elements (for showing change indicator)
  useEffect(() => {
    const checkForNewSeal = () => {
      if (containerRef.current) {
        const sortableItem = containerRef.current.closest(".SortableItem");
        if (sortableItem) {
          // The new-seal-number is 3 siblings down (seal-number -> sealed/broken -> replace -> new-seal)
          let sibling = sortableItem.nextElementSibling;
          for (let i = 0; i < 3 && sibling; i++) {
            const newSealInput = sibling.querySelector(".new-seal-number-input");
            if (newSealInput && newSealInput.value) {
              setNewSealValue(newSealInput.value);
              return;
            }
            sibling = sibling.nextElementSibling;
          }
        }
      }
    };

    // Check immediately and also after a short delay (for draft restoration)
    checkForNewSeal();
    const timer = setTimeout(checkForNewSeal, 200);
    return () => clearTimeout(timer);
  }, []);

  const formatLabel = (label) => {
    return label;
  };

  return (
    <div className="form-group seal-number" ref={containerRef}>
      {/* Show seal change indicator when there's a new seal value from draft */}
      {defaultValue && newSealValue && (
        <div 
          className="seal-change-indicator"
          style={{
            backgroundColor: "#e8f5e9",
            border: "1px solid #4caf50",
            borderRadius: "6px",
            padding: "8px 12px",
            marginBottom: "10px",
            fontSize: "14px",
            color: "#2e7d32",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}
        >
          <span style={{ fontSize: "16px" }}>🔄</span>
          <span>
            <strong>Seal changed:</strong> {defaultValue} → {newSealValue}
          </span>
        </div>
      )}
      <label className="form-label">
        <span dangerouslySetInnerHTML={{ __html: formatLabel(props.data.label) }}></span>
        {props.data.required && <span className="label-required badge badge-danger">Required</span>}
      </label>
      <input
        ref={inputRef} // Using the ref here
        type="text"
        className="form-control seal-number-input"
        name={name}
        disabled={disabled}
        readOnly={true}
        value={defaultValue} // Controlled component
        style={{ backgroundColor: "#494b4c", color: "white" }}
        placeholder="No Recorded Seal" 
      />
      <style>
        {`
          .seal-number-input::placeholder {
            color: white;
          }
        `}
      </style>
    </div>
  );
});